<template>
  <div>
    <div class="text-center font-medium mb-6">
      Estás autenticado como:
    </div>

    <div class="grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-4">
      <div>
        <label class="form-label">Nombre</label>
        <input
          :value="user.firstName"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>
      <div>
        <label class="form-label">Apellido</label>
        <input
          :value="user.lastName"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>
      <div>
        <label class="form-label">Tipo de Documento</label>
        <input
          :value="user.docType"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>
      <div>
        <label class="form-label">Número de Documento</label>
        <input
          :value="user.documentNumber"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>

      <div>
        <div class="flex items-center justify-between mb-1">
          <label class="form-label mb-0">Email</label>
          <span
            v-if="user.emailVerified"
            class="flex items-center gap-1 text-xs text-aces"
          >
            <CheckCircleIcon class="w-3.5 h-3.5" />
            Verificado
          </span>
          <span v-else class="flex items-center gap-1 text-xs text-warning-fg">
            <ExclamationCircleIcon class="w-3.5 h-3.5" />
            Pendiente
          </span>
        </div>
        <input
          :value="user.email"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>

      <div>
        <div class="flex items-center justify-between mb-1">
          <label class="form-label mb-0">Celular</label>
          <span
            v-if="user.phoneVerified"
            class="flex items-center gap-1 text-xs text-aces"
          >
            <CheckCircleIcon class="w-3.5 h-3.5" />
            Verificado
          </span>
          <span v-else class="flex items-center gap-1 text-xs text-warning-fg">
            <ExclamationCircleIcon class="w-3.5 h-3.5" />
            Pendiente
          </span>
        </div>
        <input
          :value="user.phoneNumber"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>

      <div>
        <label class="form-label">Provincia</label>
        <input
          :value="provinceName || '—'"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>
      <div>
        <label class="form-label">Iglesia</label>
        <input
          :value="churchName || '—'"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>

      <div class="lg:col-span-2">
        <label class="form-label">Coordinador</label>
        <input
          :value="coordinatorName || '—'"
          type="text"
          readonly
          class="form-input-readonly"
        />
      </div>
    </div>

    <div class="mt-6 flex flex-col gap-3 sm:flex-row sm:items-stretch sm:gap-4">
      <button
        type="button"
        class="btn-primary-inline lg:text-lg"
        @click="$emit('edit')"
      >
        Editar Datos
      </button>
      <button
        type="button"
        class="btn-secondary-inline lg:text-lg"
        @click="$emit('back')"
      >
        Volver
      </button>
    </div>
  </div>
</template>

<script>
  import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/solid";

  export default {
    name: "ProfileView",
    components: { CheckCircleIcon, ExclamationCircleIcon },
    props: {
      user: { type: Object, required: true },
      provinceName: { type: String, default: "" },
      churchName: { type: String, default: "" },
      coordinatorName: { type: String, default: "" },
    },
    emits: ["edit", "back"],
  };
</script>
